import _extends from "../../../@babel/runtime/helpers/esm/extends.js";
function isPlainObject(item) {
  if (typeof item != "object" || item === null)
    return !1;
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject(source))
    return source;
  const output = {};
  return Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  }), output;
}
function deepmerge(target, source, options = {
  clone: !0
}) {
  const output = options.clone ? _extends({}, target) : target;
  return isPlainObject(target) && isPlainObject(source) && Object.keys(source).forEach((key) => {
    key !== "__proto__" && (isPlainObject(source[key]) && key in target && isPlainObject(target[key]) ? output[key] = deepmerge(target[key], source[key], options) : options.clone ? output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key] : output[key] = source[key]);
  }), output;
}
export {
  deepmerge as default,
  isPlainObject
};
//# sourceMappingURL=deepmerge.js.map
